var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshNoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Functional-/-Refresh-/-Special",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4556522,18.6034783 C21.4556522,18.9234783 21.1965217,19.1826087 20.8765217,19.1826087 L17.9826087,19.1826087 C17.6626087,19.1826087 17.4034783,18.9234783 17.4034783,18.6034783 L17.4034783,15.7095652 C17.4034783,15.3895652 17.6626087,15.1304348 17.9826087,15.1304348 C18.3026087,15.1304348 18.5617391,15.3895652 18.5617391,15.7095652 L18.5617391,17.44 C19.3095652,16.4434783 19.7182609,15.2365217 19.7182609,13.974087 C19.7182609,10.7826087 17.1234783,8.18608696 13.9306087,8.18608696 C10.7391304,8.18608696 8.14434783,10.7826087 8.14434783,13.974087 C8.14434783,17.1652174 10.7391304,19.7617391 13.9306087,19.7617391 C14.2504348,19.7617391 14.5095652,20.0208696 14.5095652,20.3408696 C14.5095652,20.6608696 14.2504348,20.9182609 13.9306087,20.9182609 C10.1008696,20.9182609 6.98608696,17.8034783 6.98608696,13.974087 C6.98608696,10.1443478 10.1008696,7.02782609 13.9306087,7.02782609 C17.76,7.02782609 20.8765217,10.1443478 20.8765217,13.974087 C20.8765217,15.4434783 20.4121739,16.8486957 19.5652174,18.0243478 L20.8765217,18.0243478 C21.1965217,18.0243478 21.4556522,18.2834783 21.4556522,18.6034783 Z",
    id: "icon_269-path",
    fill: "#da291c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshNoCircle);
export default __webpack_public_path__ + "static/media/refresh-no-circle.bc076ab56da981b33128cf70bd23fd97.svg";
export { ForwardRef as ReactComponent };